module.exports = __webpack_public_path__ + "static/media/icn-aluminio-07.8dde5cc1.svg";